import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
// Components
import Box from '../shared/atoms/Box';
import Heading from '../shared/atoms/Heading';
import SimplifiedAddressSearch from './SimplifiedAddressSearch';
import InfosComponents from './InfosComponents';
import SearchMap from '../shared/organisms/SearchMap';

const PageContainer = styled(Box)`
  padding: 0.5rem 0 1.5rem;
  ${(p) => p.theme.mediaQueries.tablet} {
    padding: 0.75rem 0 2rem;
  }
  ${(p) => p.theme.mediaQueries.desktop} {
    padding: 1rem 0 2.5rem;
  }
`;

const SearchMapContainer = styled(Box)`
  height: ${(p) => (p.isInZone ? '45vh' : '80vh')};
  position: -webkit-relative;
  position: relative;
  margin: 0 -1.5rem;
  ${(p) => p.theme.mediaQueries.desktop} {
    height: 530px;
    margin: 0;
  }
  @media (max-width: ${(p) => p.theme.breakpoints.xs}) {
    height: ${(p) => (p.isInZone ? '40vh' : '70vh')};
  }
  @media (min-width: ${(p) => p.theme.breakpoints.lg}) {
    max-height: 480px;
  }
`;

const PageHeading = styled(Heading)`
  text-align: left;
  margin-bottom: 0.75rem !important;
  margin-top: 0 !important;
  padding: 0;
  font-size: 1.25em !important;
  line-height: 1.25 !important;
  letter-spacing: -0.01em !important;
  font-weight: 700 !important;
  color: ${(p) => p.theme.colors.black};

  ${(p) => p.theme.mediaQueries.tablet} {
    font-size: 1.375em !important;
    margin-bottom: 0.875rem !important;
  }

  ${(p) => p.theme.mediaQueries.desktop} {
    font-size: 1.5em !important;
    margin-bottom: 1rem !important;
  }
`;

const SearchSection = styled(Box)`
  margin-bottom: 2rem;
  ${(p) => p.theme.mediaQueries.tablet} {
    margin-bottom: 2.5rem;
  }
`;

export default function RepairDefaultHomeAndShops({
  zones,
  refs,
  setIndexShopClick,
  shops,
  positionError,
  indexShopClick,
  isInZone,
}) {
  const { t } = useTranslation();
  const location = useLocation();

  const isCityRepairPage = location.pathname.startsWith(
    '/reparateur-a-domicile',
  );

  return (
    <PageContainer>
      <PageHeading level={1} as="h1">
        {t('repairdefault.heading')}
      </PageHeading>

      {isCityRepairPage ? (
        <>
          <SearchMapContainer isInZone={isInZone}>
            <SearchMap
              zones={zones}
              shops={shops}
              inputSearch={shops && shops.length && !isInZone ? 'light' : true}
              refs={refs}
              setIndexShopClick={setIndexShopClick}
            />
          </SearchMapContainer>
          <InfosComponents
            isInZone={isInZone}
            shops={shops}
            refs={refs}
            positionError={positionError}
            indexShopClick={indexShopClick}
          />
        </>
      ) : (
        <>
          <SearchSection>
            <SimplifiedAddressSearch isInZone={isInZone} />
          </SearchSection>

          <InfosComponents
            horsZoneAnnuaire
            isInZone={isInZone}
            shops={shops}
            refs={refs}
            positionError={positionError}
            indexShopClick={indexShopClick}
          />
        </>
      )}
    </PageContainer>
  );
}
